import {Component, Injector} from '@angular/core';
import {AbstractControl, FormControl, FormGroup, ValidationErrors, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {DetailComponent} from 'src/app/shared/detail/detail.component';
import {Field} from 'src/app/shared/detail/detail.service';
import {MasterDetailActionSource, MasterDetailHub} from 'src/app/shared/master-detail/master-detail-hub.service';
import {ValidationService} from '../shared/cml-forms/validation.service';
import {DialogService} from '../shared/dialog/dialog.service';
import {PrenosUcetniJednotkaDetailService} from './prenos-ucetni-jednotka-detail.service';
import {ShowType, SnackMessage} from "../shared/dialog/snack-bar/snack-bar/snack-bar.component";


@Component({
    selector: 'cml-prenos-ucetni-jednotka',
    templateUrl: '../shared/detail/detail.component.html',
    styleUrls: ['../shared/detail/detail.component.scss'],
    standalone: false
})
export class PrenosUcetniJednotkaDetailComponent extends DetailComponent {

  private prenosUJdetailService: PrenosUcetniJednotkaDetailService;

  constructor(router: Router, route: ActivatedRoute, injector: Injector,
    dialogService: DialogService, masterDetailHub: MasterDetailHub, prenosUcetniJednotkaDetailService: PrenosUcetniJednotkaDetailService,validationService: ValidationService) {

    super(router, route, injector, dialogService, masterDetailHub, validationService);

    this.prenosUJdetailService = prenosUcetniJednotkaDetailService;
  }

  private async validateInputKodUj(): Promise<boolean>
  {
    for(const kod of this.prenosUJdetailService.allKodUj)
    {
      if(kod == this.entity.kodUj)
      {
        return true
      }
    }
    return false;
  }
  override async save()
  {
    if (this.form.valid)
    {
      try
      {
        this.fillEntityFromForm();
        if (this.isNew)
        {
          if(await this.validateInputKodUj())
          {
            const result = await this.detailService.create(null, this.entity);
            this.masterDetailHub.emitRefresh();
            await this.router.navigate([this.basePath, 'edit', this.detailService.getId(result)]);
          }
          else
          {
            await this.dialogService.alert({title: "Chyba", detail: "Kód účetní jednotky není správný!"});
           }
        }
        else
        {
          this.entity = await this.detailService.edit(this.entityId, this.entity);
          this.form = this.createForm(this.fields);
          this.masterDetailHub.emitRefresh(MasterDetailActionSource.detail);
          await this.detailService.openSnackBar(SnackMessage.EditEntitySucess, ShowType.Success);
        }
        this.prenosUJdetailService.autocompleteRefresh();
      }
      catch (e)
      {
        this.detailService.baseCrudService.api.isBusy$.next(false);
        await this.dialogService.handleError(e);
        this.detailService.openSnackBar(SnackMessage.OperationFailed, ShowType.Failed);
      }
    }
    else
    {
      if (this.form.errors && this.form.errors!['startDateAfterEndDate'])
      {
        await this.dialogService.alert({title: "Validace", detail: '<br>Datum „Aktivní Od“ nesmí být větší, jak datum „Aktivní Do“!<br>'});
        this.detailService.openSnackBar(SnackMessage.OperationFailed, ShowType.Failed);
      }
      let errors = this.getFormValidationErrors();
      if (errors.length > 0)
      {
        await this.dialogService.alert({title: "Validace", detail: errors.join('<br><br>')});
        this.detailService.openSnackBar(SnackMessage.OperationFailed, ShowType.Failed);
      }
    }
  }

  override createForm(fields: Field[]): FormGroup
  {
    const group: { [key: string]: AbstractControl } = {};
    fields.forEach((field, index) =>
    {
      const value = this.getEntityValue(this.entity, field.name);
      const fc = this.createFormControl(field, value);
      group[field.name] = fc;
    });
    const fg = new FormGroup(group);
    fg.setValidators(ValidationService.checkIfEndDateAfterStartDateValidator);
    fg.updateValueAndValidity();
    return fg;
  }

  override createFormControl(field: Field, value: any): AbstractControl
  {
    const validationRules: ValidationErrors = [];
    if (field.required)
    {
      validationRules['push'](Validators.required);
    }
    if (field.minLength)
    {
      validationRules['push'](Validators.minLength(field.minLength));
    }
    if (field.maxLength)
    {
      validationRules['push'](Validators.maxLength(field.maxLength));
    }
    if (field.pattern)
    {
      validationRules['push'](Validators.pattern(field.pattern));
    }
    if (field.email)
    {
      validationRules['push'](Validators.email);
    }
    if(this.isNew && field.name == 'aktivniDo')
    {
      value = new Date("9999-12-31")
    }
    if(this.isNew && field.name == 'aktivniOd')
    {
      value = new Date()
    }
    return new FormControl({value: value, disabled: field.readonly}, validationRules);
  }

  override async deleteEntity()
  {
    const conf = await this.dialogService.confirm({title: "Potvrzení odstranění", detail: `Chcete opravdu odstranit tento přenos s názvem: <strong>${this.entity.nazev}</strong>?`});
    if (!conf) return;

    await this.detailService.delete(this.entityId);
    await this.router.navigate([this.basePath]);
    this.masterDetailHub.emitRefresh(MasterDetailActionSource.detail);
    this.prenosUJdetailService.autocompleteRefresh();
  }
}
